<template>
  <v-item-group v-model="model" :value="0" @change="emitChange()">
    <v-row class="ma-0 pa-0 my-2" justify="space-around">
      <v-col
        :cols="hasBothAnimals ? 4 : 6"
        class="ma-0 pa-0 px-2"
        v-for="animal in hasBothAnimals ? 3 : 2"
        :key="`${animal}-animal`"
      >
        <v-item v-slot="{ active, toggle }">
          <v-card
            height="100"
            class="pt-4 pa-0"
            @click="toggle"
            v-bind:class="active ? 'animal-select-active-class' : 'white'"
          >
            <v-scroll-y-transition>
              <v-row
                class="ma-0 pa-0 vetalfa-row"
                align="center"
                justify="center"
              >
                <v-col class="ma-0 pa-0" align="center">
                  <v-row class="ma-0 pa-0" align="center" justify="center">
                    <v-img
                      v-if="animal == 3"
                      max-width="40px"
                      :src="animals.getAnimalIcon(1)"
                      class
                    ></v-img>
                    <v-img
                      max-width="40px"
                      :src="animals.getAnimalIcon(animal)"
                      class
                    ></v-img>
                  </v-row>
                  <p class="ma-0 pa-0 mb-3" style="font-size: 12px">
                    {{
                      plural
                        ? animals.getAnimalPlural(animal)
                        : animals.getAnimalDescription(animal)
                    }}
                  </p>
                </v-col>
              </v-row>
            </v-scroll-y-transition>
          </v-card>
        </v-item>
      </v-col>
    </v-row>
  </v-item-group>
</template>

<style>
.animal-select-active-class {
  background-color: rgb(0, 106, 149, 0.1) !important;
  color: #004662 !important;
}
</style>

<script>
import animals from "@/constants/animals.enum.js";
export default {
  name: "AnimalSelector",
  props: {
    parentModelName: { type: String, required: false, default: "animal" },
    defaultValue: { type: Number, required: false, default: null },
    plural: { type: Boolean, required: false, default: false },
    hasBothAnimals: { type: Boolean, required: false, default: false },
    clearTrigger: { default: null, required: false },
  },
  data() {
    return {
      animals,
      model: null,
    };
  },
  methods: {
    emitChange() {
      let obj = {
        id: this.parentModelName,
        value: this.model,
      };
      this.$emit("selectAnimal", obj);
    },
    clear() {
      this.model = this.defaultValue;
    },
  },
  watch: {
    clearTrigger() {
      this.clear();
    },
  },
  created() {
    this.model = this.defaultValue;
  },
};
</script>